// Utility for detecting user currency based on IP location
// Returns true if user should see INR pricing, false for USD

// Cache the result to avoid multiple API calls
let currencyCache = null;
let currencyPromise = null;

export const detectCurrency = async () => {
  // Return cached result if available
  if (currencyCache !== null) {
    return currencyCache;
  }

  // If a request is already in progress, return that promise
  if (currencyPromise) {
    return currencyPromise;
  }

  // Start new detection
  currencyPromise = (async () => {
    try {
      // Try IP-based geolocation first
      const response = await fetch('https://ipapi.co/json/');
      if (response.ok) {
        const data = await response.json();
        const timezone = data.timezone;
        const istTimezones = ['Asia/Kolkata', 'Asia/Calcutta'];
        const isINR = istTimezones.includes(timezone);
        currencyCache = isINR;
        return isINR;
      }
    } catch (error) {
      console.log('IP geolocation failed, falling back to browser timezone');
    }

    // Fallback to browser timezone
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const istTimezones = ['Asia/Kolkata', 'Asia/Calcutta'];
      const isINR = istTimezones.includes(timezone);
      currencyCache = isINR;
      return isINR;
    } catch (error) {
      // Final fallback: check UTC offset
      const now = new Date();
      const utcOffset = now.getTimezoneOffset();
      // IST is UTC+5:30, so offset should be -330 minutes
      const isINR = utcOffset === -330;
      currencyCache = isINR;
      return isINR;
    }
  })();

  return currencyPromise;
};

// Synchronous version that uses browser timezone (for initial render)
export const detectCurrencySync = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const istTimezones = ['Asia/Kolkata', 'Asia/Calcutta'];
    return istTimezones.includes(timezone);
  } catch (error) {
    // Fallback: check UTC offset
    const now = new Date();
    const utcOffset = now.getTimezoneOffset();
    return utcOffset === -330;
  }
};

// Clear cache (useful for testing or when user changes location)
export const clearCurrencyCache = () => {
  currencyCache = null;
  currencyPromise = null;
};

